import { Checkbox, Grid } from "@mui/material";
import { entryTableBoldFont, entryTableFont, productPartColumnWidths } from "../../../style/salesRecordCollectiveEntryStyle";

function EntryProduct ({product, changeNeedsPrintForEachDetail}) {

  const handleChangeNeedsPrintForEachDetail = (e) => {
    changeNeedsPrintForEachDetail(e.target.checked);
  }
  
  return (
    <Grid container columnSpacing={1}>
      <Grid item sx={{...productPartColumnWidths.salesRecordNo, ...entryTableFont}}>
        {product.salesRecordNo}
      </Grid>
      <Grid item sx={{...productPartColumnWidths.productName,  ...entryTableBoldFont}}>
        {product.productName}
      </Grid>
      <Grid item sx={{...productPartColumnWidths.needsPrintForEachDetail,  ...entryTableBoldFont}}>
        <Checkbox
          checked={product.needsPrintForEachDetail}
          onChange={handleChangeNeedsPrintForEachDetail}
        />
      </Grid>  
    </Grid>
  )
}

export default EntryProduct;